// TODO: Create a snapshot test to validate the ouput of different scenarios
import { useMemo } from 'react';
const groupBy = (array, property) => array.reduce((grouped, element) => ({
    ...grouped,
    [element[property]]: [...(grouped[element[property]] || []), element],
}), {});
function renderItems(userMenuItems, renderGroup) {
    const groupedByCategory = groupBy(userMenuItems, 'category');
    const keys = Object.keys(groupedByCategory);
    return keys.map((key, keyIndex) => {
        return renderGroup(key, groupedByCategory[key]);
    });
}
export function useRenderedUserMenuItems(userMenuItems, renderMenuGroup) {
    return useMemo(() => {
        const sortedItems = [...userMenuItems.filter(userMenuItem => userMenuItem.isVisible || userMenuItem.isVisible == null)]
            .sort((x, y) => {
            if (x.priority === y.priority) {
                return 0;
            }
            if (!x.priority && y.priority) {
                return -1;
            }
            if (x.priority && !y.priority) {
                return 1;
            }
            return x.priority <= y.priority ? -1 : 1;
        })
            // priority is intentionally omitted.
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .map(({ priority, ...itemProps }) => ({
            ...itemProps,
        }));
        return renderItems(sortedItems, renderMenuGroup);
    }, [userMenuItems, renderMenuGroup]);
}
